<div class="h-100-percent max-width-lg">
  <section class="flex flex-col items-center">
    <img class="mt-100"src="/assets/images/404-not-found.png">
    <div class="fw-700 fs-28 mat-headline-5 mt-62"> {{ 'ERROR_PAGES.404_NOT_FOUND.DESCRIPTION' | transloco }} </div>
    <div class="mat-headline-6 error-page-color accent-fg mt-10 mb-20"> {{ 'ERROR_PAGES.404_NOT_FOUND.404_ERROR' | transloco }} </div>
    <div class="flex flex-row items-center mb-20 mt-36">
      <button class="white mr-20 report-letter-spacing" type="button" (click)="goBack()"> {{ 'ERROR_PAGES.404_NOT_FOUND.BACK' | transloco }} </button>
      <button class="error-report-bg-color accent report-letter-spacing" type="button" (click)="onSupportClick()"> {{ 'ERROR_PAGES.404_NOT_FOUND.REPORT' | transloco }} </button>
    </div>
  </section>
</div>
